
import api from '../config/api';

import { formatErrorResponse } from '../utils/response';
import { makeSearchParams } from '../utils/params';

export async function createCollection(collection) {
  const response = await api.post('/collections', { collection });
  if (response.ok) {
    return {
      ok: true,
      collection: response.data,
    };
  }
  return formatErrorResponse(response);
}

export async function updateCollection(id, collection) {
  const response = await api.post(`/collections/${id}`, { collection });
  if (response.ok) {
    return {
      ok: true,
      collection: response.data,
    };
  }
  return formatErrorResponse(response);
}

export async function loadCollectionProducts(id, page = 1, options = {}) {
  const { params, ...extra } = makeSearchParams(page, options);
  const response = await api.get(`/collections/${id}/products`, {}, { params });
  if (response.ok) {
    return {
      id,
      page,
      ...extra,
      ok: true,
      products: response.data.page,
      totalPages: response.data.total_pages,
      total: response.data.total_count,
    };
  }
  return formatErrorResponse(response);
}



// WEBPACK FOOTER //
// ./src/services/CollectionServices.js